import { usePermissions } from '~/composables/use-permissions';

export default defineNuxtRouteMiddleware(() => {
  const { hasPitchPanelPermission } = usePermissions();

  if (!hasPitchPanelPermission.value) {
    return abortNavigation({ statusCode: 404 });
  }
});
